export default __webpack_public_path__ + "static/media/Path3531.7aa1ece9.svg";